import { utilHelper } from "../../_helpers";
import { SUCCESSFUL_TRANSLATION_LABEL } from "../../../components/i18n/i18n";

const relativeUrl = 'api/hotelCategory'

export const hotelCategoryService = {
	getItem,
	saveItem,
	updateItem,
	deleteItem,
	search,
	translate,
	getOptions,
	reorderItems
};

function getOptions(data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { data:data, showAlert:false })
}

//search
function search(offset, max, data){
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

//show
function getItem(id, fbDataBase) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDataBase}`, 'GET', {showAlert:false})
}

//save
function saveItem(data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

//update
function updateItem(id, data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

//delete
function deleteItem(id, fbDB) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{});
}

function translate(id, data){
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}
//reorder
function reorderItems(data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/reorder`, 'POST', { data: data });
}